// extracted by mini-css-extract-plugin
export default {"content":"SocialLoginFinish_content__fMLIW","spinnerContainer":"SocialLoginFinish_spinnerContainer__+j13P","captchaContainer":"SocialLoginFinish_captchaContainer__dTwk2"};